<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal" id="NewReplacementModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <vue-element-loading :active="isLoading" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('common.addition') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="table-scroll-x" ref="xscroll">
            <table class="table table-striped table-align-top table-1200 no-margin-bottom font-size-smaller">
              <thead>
                <tr>
                  <th class="unlimited_no_th">No.</th>
                  <th>{{ translations('replacement.reason_return') }}</th>
                  <th></th>
                  <th>{{ translations('replacement.operation_confirmation') }}</th>
                  <th>{{ translations('replacement.verification_results') }}</th>
                  <th>JAN / ITEM# / {{ translations('replacement.model_number') }}</th>
                  <th>{{ translations('replacement.number_item') }}</th>
                  <th>{{ translations('replacement.unit_price') }}</th>
                  <th>{{ translations('replacement.summary') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
              <template v-for="(tempDetail, i) in tempDetails">
                <tr :key="i">
                  <td class="unlimited_no_td">
                    {{i+1}}
                  </td>
                  <td>
                    <v-select ref="reasonSelect" v-model="selectedReason[i]" :options="reasons" @input="clicked('selectedReason', i)"></v-select>
                  </td>
                  <td>
                    <button type="button" class="btn btn-secondary" @click="addReasonForReturn(true, i)">{{ translations('common.addition') }}</button>
                    <input v-if="isPressedButton[i]" v-model="reason_for_return[i].temp_jp" class="form-control form-control-sm min-width-120 min-height-35 margin-top-5" type="text" :placeholder="reason_for_return[i].jp" @click="clicked('temp_jp', i)">
                    <input v-if="isPressedButton[i]" v-model="reason_for_return[i].temp_us" class="form-control form-control-sm min-width-120 min-height-35 margin-top-2" type="text" :placeholder="reason_for_return[i].us" @click="clicked('temp_us', i)">
                  </td>
                  <td>
                    <select v-model="tempDetail.replacement_state_id" class="custom-select keep-select">
                      <template  v-for="(state, i) in replacement_states">
                        <option :key="i" :value="state.id">{{ state.name }}</option>
                      </template>
                    </select>
                  </td>
                  <td>
                    <input v-model="tempDetail.test_result" class="form-control form-control-sm min-width-80 min-height-35" type="text">
                  </td>
                  <td>
                    <v-select v-model="selectedProduct[i]" :options="productList"></v-select>
                  </td>
                  <td>
                    <input v-on:keyup="quantityKeyUp($event,tempDetail)" v-model="tempDetail.quantity" class="form-control form-control-sm min-width-60 min-height-35 input-right" type="text">
                  </td>
                  <td>
                    <input v-model="tempDetail.unit_price" class="form-control form-control-sm min-width-80 min-height-35 input-right" type="text">
                  </td>
                  <td>
                    <input v-model="tempDetail.remarks" class="form-control form-control-sm min-width-60 min-height-35" type="text">
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <div>
            <button type="button" class="btn btn-info" @click="addRows(10)">{{ translations('replacement.add_row') }}</button>
          </div>
          <div>
            <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal" @click="addReasonForReturn()">
              {{ translations('common.close') }}</button>
            <button type="button" class="btn btn-primary margin-left-10" @click="updateDetails()">{{ translations('common.update') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'NewReplacementModal',
  components: {
    VueElementLoading
  },
  props: {
    vat: {}, // VAT
    replacementDetails: {},
    replacementStatuses: {},
    replacementReasons: {},
    replacementStates: {},
    products: {}
  },
  watch: {
    selectedProduct (v) {
      console.log(v)
      for (let i = 0; i < this.rows; i++) {
        if (this.searchProducts[v[i]]) {
          const product = this.searchProducts[v[i]]
          this.tempDetails[i].product_id = product.id
          this.tempDetails[i].item_no = product.item_no
          this.tempDetails[i].jan_code = product.jan_code
          this.tempDetails[i].model = product.model
          this.tempDetails[i].unit_price = product.unit_price
          this.tempDetails[i].row_price = product.row_price
          this.tempDetails[i].unit_price_inctax = product.unit_price_inctax
          this.tempDetails[i].taxclass_id = product.taxclass_id
          this.tempDetails[i].tax_status = product.tax_status
          this.tempDetails[i].tax_included = product.tax_included
          this.tempDetails[i].tax_rate = product.tax_rate
        }
      }
    }
  },
  data () {
    return {
      rows: 10,
      replacement_statuses: [],
      replacement_reasons: [],
      replacement_products: [],
      tempDetails: [],
      reason_for_return: [],
      testData: [],
      isLoading: false,
      isPressedButton: [],
      reasons: [],
      productList: [],
      searchReasons: {},
      searchProducts: {},
      selectedReason: [],
      selectedProduct: []
    }
  },
  created () {
    this.emptyDetail()
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.changeLoadingStatus)
  },
  computed: {
    ...mapState(['currentLanguage']),
    replacement_states () {
      const states = this.$props.replacementStates
      return this.translateStates(states)
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(state.name)
      }))
    },
    quantityKeyUp (event, tempDetail) {
      let { value } = event.target
      if (value && value <= 0) value = 1
      tempDetail.quantity = value
    },
    emptyDetail () {
      this.rows = 10
      this.tempDetails = []
      this.reason_for_return = []
      this.isPressedButton = []
      this.selectedReason = []
      this.selectedProduct = []
      for (let i = 0; i < this.rows; i++) {
        this.tempDetails.push({
          unit_price: '',
          quantity: '',
          remarks: '',
          replacement_reason_id: '',
          replacement_reason_name: '',
          replacement_state_id: 5,
          replacement_status_id: 1,
          test_result: '',
          product_id: ''
        })
        this.reason_for_return.push({
          jp: '返品理由',
          us: 'Reason for return',
          temp_jp: '',
          temp_us: ''
        })
        this.isPressedButton.push(false)
        this.selectedReason.push('')
        this.selectedProduct.push('')
      }
    },
    clicked (button, i) {
      if (button === 'temp_jp' || button === 'temp_us') {
        this.selectedReason[i] = ''
      } else if (button === 'selectedReason' && this.selectedReason[i] !== null) {
        // console.log('### selectedReason:' + this.selectedReason) // DEBUG
        this.reason_for_return[i].temp_jp = ''
        this.reason_for_return[i].temp_us = ''
        this.isPressedButton[i] = false
      } else {
        // DO NOTHING
      }
    },
    addRows (rows) {
      if (!rows) return
      for (let i = 0; i < rows; i++) {
        this.tempDetails.push({
          unit_price: '',
          quantity: '',
          remarks: '',
          replacement_reason_id: '',
          replacement_reason_name: '',
          replacement_state_id: 5,
          replacement_status_id: 1,
          test_result: '',
          product_id: ''
        })
        this.reason_for_return.push({
          jp: '返品理由',
          us: 'Reason for return',
          temp_jp: '',
          temp_us: ''
        })
        this.isPressedButton.push(false)
        this.selectedReason.push('')
        this.selectedProduct.push('')
        this.rows++ // ADD
      }
    },
    addReasonForReturn (button, i) {
      this.$refs['xscroll'].scrollTo(0, 0) // INIT
      if (i === undefined || i === null) {
        this.emptyDetail() // CLEAR ALL !!
        return // BREAK
      }
      if (button) {
        this.isPressedButton[i] = !(this.isPressedButton[i])
      } else {
        this.isPressedButton[i] = false
      }
      if (this.isPressedButton[i]) {
        this.selectedReason[i] = ''
      } else {
        this.reason_for_return[i].temp_jp = ''
        this.reason_for_return[i].temp_us = ''
      }
      this.$forceUpdate() // FORCE UPDATE // REFRESH
    },
    changeLoadingStatus () {
      this.isLoading = false
      let $this = this
      this.reasons = []
      this.productList = []
      this.searchProducts = {}
      this.searchReasons = {}
      this.$props.replacementReasons.forEach(function (reason) {
        if (reason.is_temporary !== '1') {
          $this.reasons.push(reason.name)
          $this.searchReasons[reason.name] = { id: reason.id }
        }
      })
      this.$props.products.forEach(function (product) {
        $this.productList.push(product.jan_code + ' / ' + product.item_no + ' / ' + product.model + ' / ' + product.id)
        $this.searchProducts[product.jan_code + ' / ' + product.item_no + ' / ' + product.model + ' / ' + product.id] = product
      })
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },
    async getNewReturnReasonId (i) { // REASON FOR RETURN
      try {
        let result = await this.$http.post(this.$api_url.return_add_reason, { name: this.reason_for_return[i].temp_jp, name_eng: this.reason_for_return[i].temp_us })
        if (result.data.status === true) {
          // console.log('### result.data:' + JSON.stringify(result.data))
          // console.log('### result.data.id:' + JSON.stringify(result.data.id))
          this.tempDetails[i].replacement_reason_id = result.data.id
        } else {
          this.$toastr.error(result.data, 'エラー')
        }
      } catch (error) {
        console.log('NewReplacementModal:getNewReturnReasonId:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    // updateDetails () {
    //   console.log(JSON.stringify(this.tempDetails)) // DEBUG
    //   const _async = async () => {
    //     for (let i = 0; i < this.rows; i++) {
    //       let typeNumber = this.searchProducts && this.searchProducts[this.selectedProduct[i]] && this.searchProducts[this.selectedProduct[i]].model
    //       let id = this.searchProducts && this.searchProducts[this.selectedProduct[i]] && this.searchProducts[this.selectedProduct[i]].id
    //       // this.tempDetails[i].model = this.searchProducts[this.selectedProduct[i]].model
    //       if (typeNumber) {
    //         this.tempDetails[i].model = typeNumber
    //       } else {
    //         this.tempDetails[i].model = null
    //       }
    //       if (id) {
    //         // this.tempDetails[i].product_id = this.searchProducts[this.selectedProduct[i]].id
    //         this.tempDetails[i].product_id = id
    //       } else {
    //         this.tempDetails[i].product_id = null
    //       }
    //       if (i !== 0 && !this.tempDetails[i].unit_price && !this.tempDetails[i].quantity && !this.tempDetails[i].remarks && !this.tempDetails[i].return_reason_id && !this.tempDetails[i].return_reason_name && !this.tempDetails[i].test_result && !this.tempDetails[i].product_id) {
    //         if (i >= this.rows - 1) {
    //           await this.emptyDetail()
    //           this.$refs.closeModal.click()
    //           return // BREAK
    //         } else {
    //           continue // SKIP BLANK ROW
    //         }
    //       } else {
    //         if (!this.tempDetails[i].unit_price || !this.tempDetails[i].quantity || !this.tempDetails[i].return_state_id || !this.tempDetails[i].return_status_id || !this.tempDetails[i].product_id) {
    //           this.$toastr.warning(1 + i + '行目に必要なデータを入力してください。', 'ワーニング')
    //           return // BREAK
    //         } else if (isNaN(this.tempDetails[i].unit_price) || isNaN(this.tempDetails[i].quantity)) {
    //           this.$toastr.warning(1 + i + '行目に有効な数字を入力してください。', 'ワーニング')
    //           return // BREAK
    //         }
    //       }

    //       this.tempDetails[i].unit_price = this.filterTax(this.tempDetails[i].unit_price) // VAT INPUT @Modal

    //       if (this.selectedReason[i]) {
    //         this.tempDetails[i].return_reason_id = this.searchReasons[this.selectedReason[i]].id
    //         this.tempDetails[i].return_reason_name = this.selectedReason[i] // SAVE NEW REASON
    //       } else if (this.reason_for_return[i].temp_jp) { // JP ONLY
    //         this.tempDetails[i].return_reason_name = this.reason_for_return[i].temp_jp // SAVE NEW REASON
    //         await this.getNewReturnReasonId(i)
    //       } else {
    //         this.$toastr.warning(1 + i + '行目に返品理由を入力してください。', 'ワーニング')
    //         return // BREAK
    //       }
    //       this.$props.returnDetails.push(this.tempDetails[i])
    //     }
    //     this.emptyDetail()
    //     this.$refs.closeModal.click()
    //   }
    //   _async() // ASYNC await INSIDE
    // }
    async updateDetails () {
      console.log(JSON.stringify(this.tempDetails)) // DEBUG

      const _async = async () => {
        let isError = false
        for (let i = 0; i < this.rows; i++) {
          if (this.tempDetails[i] && this.tempDetails[i].product_id) {
            const product = this.tempDetails[i]

            console.log(product)

            if (product.unit_price === '' || !product.quantity || !product.replacement_state_id || !product.replacement_status_id) {
              this.$toastr.warning(1 + i + '行目に必要なデータを入力してください。', 'ワーニング')
              isError = true
              return // BREAK
            } else if (isNaN(this.tempDetails[i].unit_price) || isNaN(this.tempDetails[i].quantity)) {
              this.$toastr.warning(1 + i + '行目に有効な数字を入力してください。', 'ワーニング')
              isError = true
              return // BREAK
            }

            if (this.selectedReason[i]) {
              product.replacement_reason_id = this.searchReasons[this.selectedReason[i]].id
              product.replacement_reason_name = this.selectedReason[i] // SAVE NEW REASON
            } else if (this.reason_for_return[i].temp_jp) { // JP ONLY
              product.replacement_reason_name = this.reason_for_return[i].temp_jp // SAVE NEW REASON
              await this.getNewReturnReasonId(i)
            } else {
              product.replacement_reason_id = 0
              product.replacement_reason_name = ''
            }

            for (let i = 0; i < product.quantity; i++) {
              const data = JSON.parse(JSON.stringify(product))
              data.quantity = 1
              this.$props.replacementDetails.push(data)
            }
          }
        }
        if (!isError) {
          this.emptyDetail()
          this.$refs.closeModal.click()
        }
      }
      _async() // ASYNC await INSIDE
    }
  }
}
</script>
